import React, { useState } from "react";
import { ArrowPathIcon } from "@heroicons/react/24/solid";
import { addCommentAdmin } from "../../../redux/reducer/commentReducer";
import { useDispatch } from "react-redux";

const AddTestimonialForm = ({ onClose, fetchData }) => {
  const [name, setName] = useState("");
  const [commentAr, setCommentAr] = useState("");
  const [commentEn, setCommentEn] = useState("");
  const [rating, setRating] = useState("");
  // const [country, setCountry] = useState("");
  const [image, setImage] = useState(null);
  const [imagePreview, setImagePreview] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(file);
      setImagePreview(URL.createObjectURL(file));
    }
  };

  const handleSubmit = async () => {
    if (!name || !commentAr || !commentEn || !rating || !image) {
      alert("Please fill in all fields");
      return;
    }

    const formData = new FormData();
    formData.append("name", name);
    formData.append("comment_AR", commentAr);
    formData.append("comment_EN", commentEn);
    formData.append("rate", Number(rating));
    if (image) {
      formData.append("image", image);
    }

    try {
      setIsLoading(true);
      await dispatch(addCommentAdmin(formData)).unwrap();
      fetchData();
      // console.log("Testimonial submitted:", Object.fromEntries(formData));
      // alert("Testimonial added successfully!");
      onClose();
    } catch (error) {
      alert("Failed to add testimonial");
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white w-[90%] sm:w-[50%] p-6 rounded-xl shadow-xl ">
        <div className="max-h-[90vh] overflow-y-scroll space-y-4">
          <h2 className="mb-4 text-xl font-bold text-gray-900">
            Add New Testimonial
          </h2>

          {/* Name */}
          <div>
            <label className="block mb-1 text-sm font-medium text-gray-700">
              Name
            </label>
            <input
              type="text"
              placeholder="e.g. Mohamed Ali"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-400 focus:outline-none"
            />
          </div>

          {/* Comment Arabic */}
          <div>
            <label className="block mb-1 text-sm font-medium text-gray-700">
              Comment (Arabic)
            </label>
            <textarea
              placeholder="أدخل تعليقك بالعربية..."
              value={commentAr}
              onChange={(e) => setCommentAr(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg resize-none focus:ring-2 focus:ring-yellow-400 focus:outline-none bg-gray-50"
              rows={3}
            />
          </div>

          {/* Comment English */}
          <div>
            <label className="block mb-1 text-sm font-medium text-gray-700">
              Comment (English)
            </label>
            <textarea
              placeholder="Enter your comment in English..."
              value={commentEn}
              onChange={(e) => setCommentEn(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg resize-none focus:ring-2 focus:ring-yellow-400 focus:outline-none bg-gray-50"
              rows={3}
            />
          </div>

          {/*Rating in one row */}
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            {/* Rating */}
            <div>
              <label className="block mb-1 text-sm font-medium text-gray-700">
                Rating (1–5)
              </label>
              <select
                value={rating}
                onChange={(e) => setRating(e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-400 focus:outline-none bg-gray-50"
              >
                <option value="">Select rating</option>
                {[1, 2, 3, 4, 5].map((num) => (
                  <option key={num} value={num}>
                    {num} Star{num > 1 ? "s" : ""}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {/* Image Upload */}
          <div>
            <label className="block mb-1 text-sm font-medium text-gray-700">
              Image
            </label>
            <input
              type="file"
              accept="image/*"
              onChange={handleImageChange}
              className="block w-full text-sm text-gray-700 file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:text-sm file:font-semibold file:bg-yellow-400 file:text-black hover:file:bg-yellow-500"
            />
            {imagePreview && (
              <img
                src={imagePreview}
                alt="Preview"
                className="object-cover mt-3 rounded-lg shadow-md w-28 h-28"
              />
            )}
          </div>

          {/* Buttons */}
          <div className="flex justify-end gap-3 pt-4">
            <button
              onClick={onClose}
              className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-200 rounded-lg hover:bg-gray-300"
            >
              Cancel
            </button>

            {isLoading ? (
              <ArrowPathIcon className="w-10 h-10 p-2 text-white bg-yellow-500 rounded-full animate-spin" />
            ) : (
              <button
                onClick={handleSubmit}
                className="px-5 py-2 text-sm font-semibold text-black rounded-lg bg-custom-yellow hover:bg-yellow-500"
              >
                Submit
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddTestimonialForm;
